import { AccountingCalendarEnum } from './../../enums/accounting-calendar.enum';
import { Component, OnInit, ViewChild } from '@angular/core';
import * as canvasDatagrid from 'canvas-datagrid';
import { ExcelService } from 'src/app/services/excel.service'; // move to relative
import { EngagementService } from 'src/app/services/engagement.service'; // move to relative
import { SourceFile } from 'src/app/models/sourceFile.model';
import { Router, ActivatedRoute } from '@angular/router';
import { SourceFileTab } from 'src/app/models/SourceFileTab';
import { CurrencyModel } from '../../models/currency.model';
import { CurrencyService } from './../../services/currency.service';
import { Sharedservice } from './../../shared-components/shared.service';
import { CoverageService } from 'src/app/services/coverage.service';
import { CoverageModel } from 'src/app/models/coverage.model';
import { EngagementModel } from '../../models/engagement.model';
import { ErrorPopUpModel } from '../../models/errorpopup.model';
import { PreviewAttributeModel } from '../../models/PreviewAttribute.model';
import { Table } from 'primeng/table';
import { MessageService } from 'primeng/api';
import { MasterHelpModel } from '../../models/MasterHelp.model';
import { MasterHelpService } from '../../services/masterhelp.service';
import { severitymessage, PreviewSourcefileComponentmessage, InputCaptureComponentmessage, LanguageConstants } from '../../shared-components/constant';
import { UserService } from '../../services/user.service';
import { UserModel } from '../../models/user.model';
import { PreviewAttributeArrayModel } from '../../models/previewAttributesArary.model';
import { TabGroupModel } from '../../models/tabGroup.model';
import { TabGroupService } from '../../services/tabGroup.service';
import { InfraService } from 'src/app/services/infra.service';
import { environment } from '../../../environments/environment.prod';
import moment from 'moment';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { AppConfigurationService } from './../../services/appConfiguration.service';
import { AppConfigurationsModel } from './../../models/appConfigurations.model';
import { Observable } from 'rxjs';
type AOA = any[][];

@Component({
  standalone: false,
    selector: 'app-preview-sourcefile',
    templateUrl: './preview-sourcefile.component.html',
    styleUrls: ['./preview-sourcefile.component.css']
})
export class PreviewSourcefileComponent implements OnInit {
    langCode: string;
    currLangTranslation: any;
    nextStep: any;
    previousStep: any;
  isEngagementReadOnly: boolean = false;
    constructor(private infraService: InfraService, private userService: UserService, private excelService: ExcelService,
        private engagementService: EngagementService, private router: Router, private route: ActivatedRoute,
        private currencyService: CurrencyService, private sharedService: Sharedservice, private coverageService: CoverageService,
      private messageService: MessageService, private masterHelpService: MasterHelpService, private appConfigService: AppConfigurationService,
        private tabGroupService: TabGroupService, private translateService: TranslateService
    ) {
      this.isEngagementReadOnly = this.appConfigService.GetConfigValueByKey("IsProjectsReadOnly");
        this.infraService.infraDetails$.subscribe((data) => {
            if (data !== undefined) {
                this.selectedTemplate = data.TemplateId.toString();
            }
        });
  }

    data: AOA = [[1, 2], [3, 4]];
    canvasDataGrid: AOA = [[1, 2], [3, 4]];
    fileName = 'SheetJS.xlsx';
    workSheets: string[] = [];
    selectedWorkSheet: string;
    myGrid: any;
    selectedCell: any;
    periodStartRow: string;
    uniqueColumnReference: string;
    accountStartRow: string;
    accountColumn: string;
    valueStartColumn: string;
    templateId: any;
    filebase64data: any;
    engagementId = +this.route.snapshot.paramMap.get('id');
    engagementCurrency = 0;
    sourceFiles: SourceFile[];
    sourceFileTabs: SourceFileTab;
    public currencies: CurrencyModel[];
    previewFileName: string;
    tabName: string;
    globalPeriod = 0;
    globalEntityLevel1 = 0;
    globalEntityLevel2 = 0;
    globalCurrency: number;
    coverages: CoverageModel[] = [];
    selectAll: boolean;
    currentSelection = {};
    loadspinner = false;
    cols: any[];
    public filesData: PreviewAttributeModel[];
    validationList: any[];
    @ViewChild('dt', { static: true }) private _table: Table;
    display = false;
    show = false;
    private loggedInUserId: number;
    selectedPeriods: any[] = [];
    maps: any;
    singalfile = false;
    errorModel: ErrorPopUpModel = new ErrorPopUpModel();
    yearTypeHeader: string = null;
    isFiscalMonthDec = true;
    public tabGroups: TabGroupModel[];
    recordMessage = '';
    isSheetRowsExceeded = false;
    maxNumberOfSheetRows = 20000;
    private selectedTemplate: string;
    isAccountCalendarP12 = true;
    isPeriodIdYearLesser: boolean;
    firstDateOfFiscalYear = '';
    isAccountCalender445 = false;
    confirmdisplay = false;

    private initializeCanvasGrid() {
        this.myGrid = canvasDatagrid({ parentNode: document.getElementById('grid'), data: [], });
        this.myGrid.style.height = '500px';
        this.myGrid.style.width = '100%';
    }

    ngOnInit() {
        this.langCode = localStorage.getItem(LanguageConstants.LANG_CODE);
        this.currLangTranslation = this.translateService.translations[this.langCode];
        this.nextStep = this.currLangTranslation.actionButtons.nextStep;
        this.previousStep = this.currLangTranslation.actionButtons.previousStep;

        this.translateService.onLangChange.subscribe((langEvent: LangChangeEvent) => {
            this.currLangTranslation = langEvent.translations;
            this.previousStep = this.currLangTranslation.actionButtons.previousStep;
            this.nextStep = this.currLangTranslation.actionButtons.nextStep;
        });

        this.route
            .queryParams
            .subscribe(params => {
                let paramvalue = params['order'];
                if (paramvalue == "2") {
                    this.errorModel.confirmIsDisplay = true;
                    this.errorModel.headerTitle = 'Notification';
                    this.errorModel.displayMessage = InputCaptureComponentmessage.ConfirmMessage.ConfirmPreviewProcessing;
                    this.confirmdisplay = false;
                }
            });

        this.sharedService.setactiveindex(1);
        this.cols = [
            { field: 'IsProcessed', header: 'IsProcessed', visible: false, isEditable: false },
            { field: 'IsApplicable', header: 'Is Applicable', visible: true, isEditable: false },
            { field: 'sourceId', header: 'Source Id', visible: false, isEditable: false },
            { field: 'fileName', header: 'File Name', visible: true, isEditable: false },
            { field: 'tabId', header: 'Tab Id', visible: false, isEditable: false },
            { field: 'tabName', header: 'Tab Name', visible: true, isEditable: false },
            { field: 'preview', header: 'Preview', visible: true, isEditable: false },
            { field: 'currencyId', header: 'Currency', visible: true, isEditable: false },
            { field: 'tabGroupId', header: 'Group', visible: true, isEditable: false },
            { field: 'periodId', header: 'Period', visible: true, isEditable: false },
            { field: 'periodIdYear', header: 'Period', visible: true, isEditable: false },
            { field: 'periodPreview', header: 'Period Preview', visible: true, isEditable: false },
            { field: 'periodPreviewYear', header: 'Period Preview', visible: true, isEditable: false },
            { field: 'YearType', header: 'FY/Calendar year', visible: false, isEditable: false },
            { field: 'businessSegment1', header: 'Business Segment 1', visible: true, isEditable: false },
            { field: 'entity1Id', header: 'Business Segment 1', group: 'entity1', visible: false, isEditable: false },
            { field: 'entity1Preview', header: 'Business Segment 1 Preview', group: 'entity1', visible: false, isEditable: false },
            { field: 'businessSegment2', header: 'Business Segment 2', visible: true, isEditable: false },
            { field: 'entity2Id', header: 'Business   Segment 2', group: 'entity2', visible: false, isEditable: false },
            { field: 'entity2Preview', header: 'Business Segment 2 Preview', group: 'entity2', visible: false, isEditable: false }
        ];

        this.loadspinner = true;
        setTimeout(() => {
            this.initializeCanvasGrid();
        }, 1000);


        this.coverageService.getAllCoverages().subscribe((data: CoverageModel[]) => {
            this.coverages = data;
            // get the tab groups
            this.tabGroupService.getAllTabGroups().subscribe((tabGroupData: TabGroupModel[]) => {
                this.tabGroups = tabGroupData;
                this.getCurrencies();
            });

        });

        this.validationList = [{ key: 'periodId', value: 'periodPreview', isInvalid: 'invalidPeriod' },
        { key: 'periodIdYear', value: 'periodPreviewYear', isInvalid: 'invalidPeriodYear' },
        { key: 'entity1Id', value: 'entity1Preview', isInvalid: 'invalidEntity1' },
        { key: 'entity2Id', value: 'entity2Preview', isInvalid: 'invalidEntity2' },
        { key: 'YearType', value: 'YearType', isInvalid: 'invalidYearType' },
        { key: 'entity2IdSelection', value: 'entity2IdSelection', isInvalid: 'invalidEntity2Selection' },

        ];
    }

    getFilesData() {
        this.engagementService.getFilesData(this.engagementId).subscribe((data: PreviewAttributeModel[]) => {
            data.length > 0 && data[0]['FiscalYear_Month'] === 12 ? this.isFiscalMonthDec = true : this.isFiscalMonthDec = false;
            this.cols[13]['visible'] = !this.isFiscalMonthDec;
            if (this.cols[13]['visible'] === true && this.isAccountCalendarP12 !== true) {
                this.cols[13]['visible'] = false;
            }
            this.filesData = data;
            if (this.filesData.length === 1) {
                this.filesData[0].IsApplicable = true;
                this.singalfile = true;
            }

            this.filesData.map((c) => {
                if (!(c.currencyId > 0)) {
                    c.currencyId = this.globalCurrency;
                }
                if (c.tabGroupId == 0) {
                    c.tabGroupId = this.tabGroups[0].id;
                }
            });
            let expandentity1flag = false;
            let expandentity2flag = false;


            this.engagementService.getAllEntity(this.engagementId).subscribe((resp: any[]) => {


                this.filesData.forEach(file => {


                    if (file.entity1Id !== 0) {
                        resp.map(x => {
                            if (x.EntityLevel === 1 && x.SourceFileTabId === file.tabId) {
                                file.entity1Preview = x.EntityName;
                            }
                        });
                        expandentity1flag = true;
                    }

                    if (file.entity2Id !== 0) {
                        resp.map(x => {
                            if (x.EntityLevel === 2 && x.SourceFileTabId === file.tabId) {
                                file.entity2Preview = x.EntityName;
                            }
                        });



                        expandentity2flag = true;
                    }



                });

                if (expandentity1flag !== false) {
                    this.onBusinessSegClick('businessSegment1', 'entity1');
                } else {
                    this.hideShowBusinessSegment2(false);
                }

                if (expandentity2flag !== false) {
                    this.onBusinessSegClick('businessSegment2', 'entity2');
                }

            });


            this.engagementService.getAllPeriod(this.engagementId).subscribe((resp: any[]) => {

                this.filesData.forEach(file => {
                    resp.map(x => {
                        if (x.SourceFileTabId === file.tabId) {
                            if (file.periodIdYear !== 3) {
                                file.periodPreviewYear = (!this.isAccountCalender445) ? x.Year : x.EndDate;
                            }

                            file.periodPreview = x.PeriodName;

                        }
                    });
                });

                this.ValidateFilesData();
                this.loadspinner = false;
            });
        });
    }
    getCurrencies() {

        this.currencyService.getAllCurrencies().subscribe((data: CurrencyModel[]) => {

            this.currencies = data;


            this.engagementService.getEngagement(this.engagementId).subscribe((resp: EngagementModel) => {
                if (resp.FirstDateOfFiscalYear !== undefined && resp.FirstDateOfFiscalYear !== null) {
                    this.firstDateOfFiscalYear = moment(resp.FirstDateOfFiscalYear).format('YYYY');
                }
                if (resp.AccCalendarId !== undefined && resp.FirstDateOfFiscalYear !== null) {
                    this.isAccountCalendarP12 = (resp.AccCalendarId === AccountingCalendarEnum.P12) ? true : false;
                } else {
                    this.isAccountCalendarP12 = true;
                }
                this.globalCurrency = resp.ReportingCurrencyId;
                this.isAccountCalender445 = ((resp.AccCalendarId !== AccountingCalendarEnum.P12) && (resp.AccCalendarId !== AccountingCalendarEnum.P13)) ? true : false;
                if (this.isAccountCalender445) {
                    if (this.cols.length) {
                        this.cols.forEach((col) => {
                            if (col.field === 'periodId' || col.field === 'periodPreview') {
                                col.visible = false;
                            }
                        });
                    }
                }
                this.getFilesData();

            });
        });
    }

    inputSelection(rowId: number, propertyName: string) {
        this.currentSelection = { 'rowId': rowId, 'propertyName': propertyName };
    }

    previewTab(sourceFileId, sourceFileTab, fileName, sheetRows, size) {
        this.loadspinner = true;

        this.previewFileName = fileName;
        this.tabName = sourceFileTab;
        const tabSize = Math.abs(size / this.filesData.filter(x => x.sourceId === sourceFileId).length);
        if (tabSize > environment.maxPreviewFileSize) {
            this.recordMessage = this.currLangTranslation.step2.errorMessage.previewSheetSizeExceedMessage;
            this.isSheetRowsExceeded = true;
            this.loadspinner = false;
            return;
        }

        if (parseInt(sheetRows) > this.maxNumberOfSheetRows) {
            this.recordMessage = this.currLangTranslation.step2.errorMessage.previewSheetRowExceedCountMessage;
            this.isSheetRowsExceeded = true;
            this.loadspinner = false;
            return;
        }


        const xhr = this.engagementService.getSourceFilesContent(sourceFileId);

        const reader: FileReader = new FileReader();
        // let binary = '';
        /*To perform reading successful on all browsers namely IE, chrome, firefox.*/
        let binary = '';
        FileReader.prototype.readAsBinaryString = undefined;
        if (FileReader.prototype.readAsBinaryString === undefined) {
            FileReader.prototype.readAsBinaryString = function (fileData) {
                const pt = this;
                reader.onload = function (e) {
                    let ia = null;
                    let length = 0;
                    if (e) {
                        ia = new Uint8Array(e.target['result'] as ArrayBuffer);
                        length = ia.length;
                    }
                    for (let i = 0; i < length; i++) {
                        binary += String.fromCharCode(ia[i]);
                    }
                };

                reader.readAsArrayBuffer(fileData);
            };
        }
        xhr.onreadystatechange = function () {
            if (xhr.readyState === 4) {
                if (xhr.status === 200) {

                    const contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
                    const blob = new Blob([xhr.response], { type: contentType });
                    reader.readAsBinaryString(blob);

                } else {

                }
            }
        };
        xhr.send();

        reader.onloadend = () => {
            if (binary === '') {
                this.filebase64data = reader.result;
            } else {
                this.filebase64data = binary.toString();
            }
            this.workSheets = this.excelService.readWorkSheetNames(this.filebase64data);
            this.isSheetRowsExceeded = false;
            let excelSheetData = this.excelService.readWorkBookToArrayForCanvasDataGridBinary(this.filebase64data,
                this.workSheets.filter(workSheet => workSheet === '' + this.tabName)[0], this.selectedTemplate);

            if (excelSheetData !== undefined && excelSheetData !== null) {
                this.isSheetRowsExceeded = false;
                if (document.getElementById('grid') === null || document.getElementById('grid') === undefined) {
                    setTimeout(() => {
                        this.initializeCanvasGrid(); this.myGrid.data = excelSheetData; excelSheetData = null;
                    }, 500);
                } else {
                    this.myGrid.data = excelSheetData;
                    excelSheetData = null;
                }
                this.recordMessage = '';
            }

            this.loadspinner = false;
        };

    }

    IsProcessedChecked(chbElement: any, index: number) {
        this.ValidateSingleFileData(this.filesData[index]);
    }

    ValidateSingleFileData(dt) {
        this.templateId = dt.TemplateId;
        if (dt.IsApplicable) {
            let isErrorPopupAlreadyShown = false;

            this.validationList.forEach((vali) => {

                // Check business segment selections
                // "Id": 1,"Coverage": "In file name" , "Id": 2,"Coverage": "In tab name", "Id": 3,"Coverage": "In sheet" , "Id": 4,"Coverage":
                // "None"
                if (vali.key === 'entity2IdSelection') {
                    dt['invalidEntity2Selection'] = false;
                    if (dt.entity1Id != 0 && dt.entity2Id != 0) {
                        if (parseInt(dt.entity1Id) === 3 && (parseInt(dt.entity2Id) === 1 || parseInt(dt.entity2Id) === 2)) {
                            dt['invalidEntity2Selection'] = true;
                        }
                        if (parseInt(dt.entity1Id) === 4 && parseInt(dt.entity2Id) === 4) {
                            dt['invalidEntity2Selection'] = true;
                        }
                    }
                } else if (this._table.columns.findIndex(col => col.field === vali.value && col.visible) > 0) {
                    // if (parseInt(dt[vali.key]) !== 3 && parseInt(dt[vali.key]) !== 4 && dt[vali.key] != null) {
                    //   if (parseInt(dt[vali.key]) == 4) {
                    //     dt[vali.isInvalid] = false;
                    //   }
                    if (parseInt(dt[vali.key]) !== 3 && dt[vali.key] != '') {
                        if (parseInt(dt[vali.key]) === 4) {
                            dt[vali.isInvalid] = false;
                        } else if (parseInt(dt[vali.key]) !== 4) {
                            dt[vali.isInvalid] = false;
                        } else {
                            dt[vali.isInvalid] = (dt[vali.value] === undefined || dt[vali.value] === '');
                        }

                        if (!dt[vali.isInvalid] && vali.key === this.validationList[2].key) {
                            if (!dt[vali.value]) {
                                dt[vali.isInvalid] = true;

                            }
                        }

                        if (!dt[vali.isInvalid] && (vali.key === this.validationList[3].key)) {

                            if (!dt[vali.value]) {
                                dt[vali.isInvalid] = true;
                            }
                        }

                        if (!dt[vali.isInvalid] && vali.key === this.validationList[0].key) {
                            if (this.isAccountCalendarP12) {
                                dt[vali.isInvalid] = this.sharedService.validateDateWithRegex(dt[vali.value], dt.TemplateId, 'periodPreview');
                                if (parseInt(dt[vali.key]) === 4 && dt[vali.value] !== '' && dt[vali.value] !== undefined && dt[vali.isInvalid]) {
                                    this.errorModel.confirmIsDisplay = true;
                                    this.errorModel.displayMessage = this.currLangTranslation.step2.errorMessage.invalidMonthError;
                                    isErrorPopupAlreadyShown = true;
                                }
                            } else if (!this.isAccountCalender445) {
                                const periodHash = this.filterInt(dt[vali.value]);
                                if (isNaN(periodHash) || periodHash > 13 || periodHash <= 0) {
                                    dt[vali.isInvalid] = true;
                                }
                            }
                        } else if (!dt[vali.isInvalid] && vali.key === this.validationList[1].key) {

                            if (this.isAccountCalender445) {
                                dt[vali.isInvalid] = this.sharedService.validateEndDateWithRegex(dt[vali.value], dt.TemplateId, 'periodPreviewYear');
                            } else {
                                dt[vali.isInvalid] = this.sharedService.validateDateWithRegex(dt[vali.value], dt.TemplateId, 'periodPreviewYear');
                            }

                            if (parseInt(dt[vali.key]) === 4 && dt[vali.value] !== '' && dt[vali.value] !== undefined && dt[vali.isInvalid]) {
                                if (this.isAccountCalendarP12) {
                                    if (!isErrorPopupAlreadyShown) {
                                        this.errorModel.confirmIsDisplay = true;
                                        this.errorModel.displayMessage = this.currLangTranslation.step2.errorMessage.invalidYearError;
                                    }
                                }

                            }
                            if (!this.isAccountCalendarP12 && !dt[vali.isInvalid] && !this.isAccountCalender445) {
                                const reg1 = /^[0-9]{2}$/;
                                const yearPreview = parseInt(dt[vali.value], 10);
                                const yy = parseInt(this.firstDateOfFiscalYear.slice(-2), 10);
                                const yyyy = parseInt(this.firstDateOfFiscalYear, 10);
                                // Period year validation for fiscal year and fiscal end date
                                if (this.isFiscalMonthDec) {
                                    if (reg1.test(dt[vali.value])) {
                                        dt[vali.isInvalid] = (yy > yearPreview) ? true : false;

                                        this.isPeriodIdYearLesser = this.isPeriodIdYearLesser ? true : dt[vali.isInvalid];
                                    } else {
                                        dt[vali.isInvalid] = (yyyy > yearPreview) ? true : false;
                                        this.isPeriodIdYearLesser = this.isPeriodIdYearLesser ? true : dt[vali.isInvalid];
                                    }
                                } else {
                                    if (reg1.test(dt[vali.value])) {
                                        dt[vali.isInvalid] = (yy >= yearPreview) ? true : false;

                                        this.isPeriodIdYearLesser = this.isPeriodIdYearLesser ? true : dt[vali.isInvalid];
                                    } else {
                                        dt[vali.isInvalid] = (yyyy >= yearPreview) ? true : false;
                                        this.isPeriodIdYearLesser = this.isPeriodIdYearLesser ? true : dt[vali.isInvalid];
                                    }

                                }

                            }
                        }
                    } else {
                        dt[vali.isInvalid] = false;

                    }

                    if (vali.key === 'YearType' && parseInt(dt['periodIdYear']) !== 3 && dt['periodIdYear'] != '') {
                        if (dt['YearType'] == 0 || dt['YearType'] === '' || typeof (dt['YearType']) === undefined) {
                            dt['invalidYearType'] = true;
                        } else {
                            dt['invalidYearType'] = false;
                        }
                    }

                    if (parseInt(dt[vali.key]) === 4 && vali.key !== this.validationList[1].key) {
                        if (!this.isAccountCalendarP12) {
                            if (vali.key === this.validationList[0].key && !dt[vali.isInvalid]) {
                                if (parseInt(dt[vali.key], 10) === 4 && (dt[vali.value] === '' || dt[vali.value] === undefined) && !dt[vali.isInvalid]) {
                                    dt[vali.isInvalid] = true;
                                }
                            }
                        } else {
                            dt[vali.isInvalid] = false;
                        }
                    }
                }
            });
        } else {
            this.validationList.forEach((x) => {
                dt[x.isInvalid] = false;
            });
        }
    }

    filterInt(value) {
        if (/^[-+]?(\d+|Infinity)$/.test(value)) {
            return Number(value);
        } else {
            return NaN;
        }
    }


    ValidateFilesData() {
        // Perform validation

        this.filesData.filter(o => o.IsApplicable).map((dtObj) => {
            this.ValidateSingleFileData(dtObj);
        });

        this.filesData.filter(o => !o.IsApplicable).map((dtObj) => {
            this.validationList.forEach((x) => {
                dtObj[x.isInvalid] = false;
            });
        });


        // check if any obj has invalid property set
        return (this.filesData.filter(o => o.IsApplicable).findIndex(obj => obj.invalidPeriod || obj.invalidYearType || obj.invalidPeriodYear
            || obj.invalidEntity1 || obj.invalidEntity2 || obj.invalidEntity2Selection) === -1);
    }

    UpdateSourceFileAndTab() {
        if (this.ValidateFilesData()) {
            this.loadspinner = true;
            if (this.filesData.filter(w => w.IsApplicable === true).length === 0) {
                this.loadspinner = false;
                this.errorModel.confirmIsDisplay = true;
                this.errorModel.displayMessage = this.currLangTranslation.step2.errorMessage.emptyCheckBoxError;
                // this.messageService.add({ key: severitymessage.key, severity: severitymessage.error, summary: PreviewSourcefileComponentmessage.
                // ErrorMessage.EmptyCheckBoxError, detail: PreviewSourcefileComponentmessage.ErrorMessage.EmptyCheckBoxError });
                return false;
            }
            // validate grouping
            let key1;
            let key2;
            const uniqueGroups = {};
            this.filesData.filter(o => o.IsApplicable).forEach((x) => {
                if (this.isAccountCalender445) {
                    key1 = x.periodIdYear + '-' + x.entity1Id + '-' + x.entity2Id;
                } else {
                    key1 = x.periodId + '-' + x.periodIdYear + '-' + x.entity1Id + '-' + x.entity2Id;
                }

                if (!uniqueGroups[x.tabGroupId]) {
                    uniqueGroups[x.tabGroupId] = Object.assign({}, x);
                    this.filesData.filter(o1 => o1.IsApplicable && o1.tabGroupId === x.tabGroupId).forEach((x1) => {
                        if (this.isAccountCalender445) {
                            key2 = x1.periodIdYear + '-' + x1.entity1Id + '-' + x1.entity2Id;
                        } else {
                            key2 = x1.periodId + '-' + x1.periodIdYear + '-' + x1.entity1Id + '-' + x1.entity2Id;
                        }

                        if (key1 !== key2) {
                            x1.invalidTabGroupId = true;
                        } else {
                            x1.invalidTabGroupId = false;
                        }
                    });
                }
            });

            if (this.filesData.filter(w => w.IsApplicable === true && w.invalidTabGroupId === true).length > 0) {
                this.loadspinner = false;
                if (this.isAccountCalender445) {
                    this.errorModel.confirmIsDisplay = true;
                    this.errorModel.displayMessage = this.currLangTranslation.step2.errorMessage.groupEndDateValidCheckError;
                } else {
                    this.errorModel.confirmIsDisplay = true;
                    this.errorModel.displayMessage = this.currLangTranslation.step2.errorMessage.groupValidCheckError;
                }
                return false;
            }

            // Period is empty then showing select pop up.
            if (!this.isAccountCalendarP12 && !this.isAccountCalender445) {
                this.maps = this.filesData.filter(w => w.IsApplicable === true && w.periodId == 0);
                if (this.maps.length !== 0) {
                    this.maps.forEach(element => {
                        this.selectedPeriods.push({ PeriodId: element.periodId });
                    });
                    let i: number;
                    for (i = 0; i <= this.selectedPeriods.length; i++) {
                        if (this.selectedPeriods[i].PeriodId == '') {
                            this.loadspinner = false;
                            this.errorModel.confirmIsDisplay = true;
                            this.errorModel.displayMessage = this.currLangTranslation.step2.errorMessage.periodHashError;
                            return false;
                        }
                    }
                }
            }

            this.maps = this.filesData.filter(w => w.IsApplicable === true && w.periodIdYear == 0);
            if (this.maps.length !== 0) {
                this.maps.forEach(element => {
                    this.selectedPeriods.push({ PeriodYearId: element.periodIdYear });
                });
                let i: number;
                for (i = 0; i <= this.selectedPeriods.length; i++) {
                    if (this.selectedPeriods[i].PeriodYearId === '') {
                        if (this.isAccountCalender445) {
                            this.loadspinner = false;
                            this.errorModel.confirmIsDisplay = true;
                            this.errorModel.displayMessage = this.currLangTranslation.step2.errorMessage.endDateCheckError;
                        } else {
                            this.loadspinner = false;
                            this.errorModel.confirmIsDisplay = true;
                            this.errorModel.displayMessage = this.currLangTranslation.step2.errorMessage.periodYearCheckError;
                        }
                        return false;
                    }
                }
            }

            // Start --to check if applicable tab is more than 36

            const applicableTab = this.filesData.filter(x => x.IsApplicable === true && x.IsProcessed === false);
            if (applicableTab.length > 36) {
                this.loadspinner = false;
                this.errorModel.headerTitle = this.currLangTranslation.labels.warning;
                this.errorModel.confirmIsDisplay = true;
                this.errorModel.displayMessage = this.currLangTranslation.step2.errorMessage.invalidTab;
                return false;
            }

            // end
            const filesdataFiltered = JSON.parse(JSON.stringify(this.filesData));
            filesdataFiltered.forEach(function (x) {
                delete x.fileName;
                delete x.tabName;
            });
            const filesDataArray: PreviewAttributeArrayModel = new PreviewAttributeArrayModel();
            filesDataArray.EngagementId = this.engagementId;
            filesDataArray.previewDataList = filesdataFiltered;
            if (filesDataArray.previewDataList.length !== 0) {
                this.engagementService.saveFilesData(filesDataArray).subscribe(data => {
                    this.loadspinner = false;
                    this.selectedPeriods = [];
                    this.router.navigate(['/engagement/', this.engagementId, 'inputcapture']);
                }, error => {

                    this.loadspinner = false;
                });
            } else {
                this.router.navigate(['/engagement/', this.engagementId, 'inputcapture']);
            }
        } else {
            this.selectedPeriods = [];
            let iserrorDiplay = false;
            this.maps = this.filesData.filter(w => w.periodId != 0 && w.periodPreview != null);
            if (this.maps.length !== 0) {
                this.maps.forEach((x) => {
                    if (this.isAccountCalendarP12) {
                        if (!isNaN(x.periodPreview) && (x.periodPreview > 12 || x.periodPreview <= 0) && x.IsApplicable && x.periodPreview !== '') {
                            this.errorModel.confirmIsDisplay = true;
                            this.errorModel.displayMessage = this.currLangTranslation.step2.errorMessage.monthValidCheckError;
                            iserrorDiplay = true;
                        } else {
                            if (x.invalidPeriod) {
                                this.errorModel.confirmIsDisplay = true;
                                this.errorModel.displayMessage = this.currLangTranslation.step2.errorMessage.emptyBoxError;
                                iserrorDiplay = true;
                            }
                        }
                    } else if (this.isAccountCalender445) {
                        if (x.IsApplicable && x.isInvalidPeriodYear !== '' && iserrorDiplay) {
                            this.messageService.add({
                                key: this.currLangTranslation.severitymessage.key, severity: severitymessage.error, summary: this.currLangTranslation.severitymessage.notification,
                                detail: this.currLangTranslation.step2.errorMessage.endDateTabMissedError, sticky: true, closable: true
                            });
                            iserrorDiplay = true;
                        }
                    } else {
                        const periodNumber = this.filterInt(x.periodPreview);
                        if ((x.periodPreview > 13 || x.periodPreview <= 0 || isNaN(periodNumber)) && x.IsApplicable && x.periodPreview !== '') {
                            this.errorModel.confirmIsDisplay = true;
                            this.errorModel.displayMessage = this.currLangTranslation.step2.errorMessage.invalidPeriodNumberError;
                            iserrorDiplay = true;
                        }
                    }
                });
            }

            if (!iserrorDiplay) {

                if ((this.filesData.filter(x => x.IsApplicable && x.periodId === 4 && x.periodPreview !== '' && x.invalidPeriod).length > 0)) {
                    if (this.isAccountCalendarP12) {
                        this.errorModel.confirmIsDisplay = true;
                        this.errorModel.displayMessage = this.currLangTranslation.step2.errorMessage.invalidMonthError;
                    } else {
                        this.errorModel.confirmIsDisplay = true;
                        this.errorModel.displayMessage = this.currLangTranslation.step2.errorMessage.invalidPeriodNumberError;
                    }
                } else if ((this.filesData.filter(x => x.IsApplicable &&
                    x.periodIdYear === 4 && x.periodPreviewYear !== '' && x.invalidPeriodYear)
                    .length > 0)) {
                    if (!this.isAccountCalender445 && !this.isAccountCalendarP12) {
                        if (this.isFiscalMonthDec) {
                            this.messageService.add({
                                key: this.currLangTranslation.severitymessage.key, severity: severitymessage.error, summary: this.currLangTranslation.severitymessage.notification,
                                detail: this.currLangTranslation.step2.errorMessage.invalidFiscalYearError,
                                sticky: true, closable: true
                            });
                        } else {
                            this.messageService.add({
                                key: this.currLangTranslation.severitymessage.key, severity: severitymessage.error, summary: this.currLangTranslation.severitymessage.notification,
                                detail: this.currLangTranslation.step2.errorMessage.invalidFiscalYearErrorForNonDec,
                                sticky: true, closable: true
                            });
                        }

                    } else if (this.isAccountCalender445) {
                        if (this.templateId === 1) {
                            this.messageService.add({
                                key: this.currLangTranslation.severitymessage.key, severity: severitymessage.error, summary: this.currLangTranslation.severitymessage.notification,
                                detail: this.currLangTranslation.step2.errorMessage.endDateValidationUSTemplateFormatError,
                                sticky: true, closable: true
                            });
                        } else {
                            this.messageService.add({
                                key: this.currLangTranslation.severitymessage.key, severity: severitymessage.error, summary: this.currLangTranslation.severitymessage.notification,
                                detail: this.currLangTranslation.step2.errorMessage.endDateValidationOtherTemplateFormatError,
                                sticky: true, closable: true
                            });
                        }
                    }
                } else if ((this.filesData.filter(x => x.IsApplicable && x.periodPreviewYear !== '' &&
                    x.invalidPeriodYear && this.isAccountCalender445)
                    .length > 0)) {
                    if (this.templateId === 1) {
                        this.messageService.add({
                            key: this.currLangTranslation.severitymessage.key, severity: severitymessage.error,
                            summary: this.currLangTranslation.severitymessage.notification,
                            detail: this.currLangTranslation.step2.errorMessage.endDateValidationUSTemplateFormatError, sticky: true, closable: true
                        });
                    } else {
                        this.messageService.add({
                            key: this.currLangTranslation.severitymessage.key, severity: severitymessage.error, summary: this.currLangTranslation.severitymessage.notification,
                            detail: this.currLangTranslation.step2.errorMessage.endDateValidationOtherTemplateFormatError,
                            sticky: true, closable: true
                        });
                    }
                } else if ((this.filesData.filter(x => x.IsApplicable && (x.periodPreviewYear !== '' || x.periodPreviewYear === '') && x.invalidPeriodYear && !this.isAccountCalender445)
                    .length > 0)) {
                    if (this.isPeriodIdYearLesser) {
                        this.isPeriodIdYearLesser = false;
                        if (this.isFiscalMonthDec) {
                            this.messageService.add({
                                key: this.currLangTranslation.severitymessage.key, severity: severitymessage.error, summary: this.currLangTranslation.severitymessage.notification,
                                detail: this.currLangTranslation.step2.errorMessage.invalidFiscalYearError,
                                sticky: true, closable: true
                            });
                        } else {
                            this.messageService.add({
                                key: this.currLangTranslation.severitymessage.key, severity: severitymessage.error, summary: this.currLangTranslation.severitymessage.notification,
                                detail: this.currLangTranslation.step2.errorMessage.invalidFiscalYearErrorForNonDec,
                                sticky: true, closable: true
                            });
                        }
                    } else {
                        this.errorModel.confirmIsDisplay = true;
                        this.errorModel.displayMessage = this.currLangTranslation.step2.errorMessage.emptyBoxError;
                    }

                } else if ((this.filesData.filter(x => x.IsApplicable && !x.invalidPeriodYear && x.invalidYearType).length > 0)) {
                    this.errorModel.confirmIsDisplay = true;
                    this.errorModel.displayMessage = this.currLangTranslation.step2.errorMessage.invalidYearType;
                } else if (this.filesData.filter(w => w.IsApplicable && w.invalidEntity2Selection === true &&
                    (w.entity1Id === 3 && (w.entity2Id === 1 || w.entity2Id === 2))).length > 0) {
                    this.errorModel.confirmIsDisplay = true;
                    this.errorModel.displayMessage = this.currLangTranslation.step2.errorMessage.bSegmentInTheSheetMessage;
                } else if (this.filesData.filter(w => w.IsApplicable && w.invalidEntity2Selection === true &&
                    (w.entity1Id === 4 && w.entity2Id === 4)).length > 0) {
                    this.errorModel.confirmIsDisplay = true;
                    this.errorModel.displayMessage = this.currLangTranslation.step2.errorMessage.bSegmentNoneMessage;
                } else {
                    // logic for when end date and business segement are empty
                    if (this.isAccountCalender445) {
                        if (this.filesData.filter(w => w.IsApplicable && w.invalidPeriodYear === true && (w.invalidEntity1 === true || w.invalidEntity2 === true)).length > 0) {
                            this.errorModel.confirmIsDisplay = true;
                            this.errorModel.displayMessage = this.currLangTranslation.step2.errorMessage.emptyBoxError;
                        } else if (this.filesData.filter(w => w.IsApplicable && w.invalidPeriodYear === false && (w.invalidEntity1 === true || w.invalidEntity2 === true)).length > 0) {
                            this.errorModel.confirmIsDisplay = true;
                            this.errorModel.displayMessage = this.currLangTranslation.step2.errorMessage.emptyBoxError;
                        } else {
                            this.messageService.add({
                                key: this.currLangTranslation.severitymessage.key, severity: severitymessage.error
                                , summary: this.currLangTranslation.severitymessage.notification, detail: this.currLangTranslation.step2.errorMessage.endDateTabMissedError, sticky: true, closable: true
                            });
                        }
                    } else {
                        this.errorModel.confirmIsDisplay = true;
                        this.errorModel.displayMessage = this.currLangTranslation.step2.errorMessage.emptyBoxError;
                    }
                }
            }

        }
    }



    applyAll(isChecked) {
        let newTable = [];
        newTable = JSON.parse(JSON.stringify(this.filesData));
        newTable.map(x => {
            if (x.IsProcessed !== 1) {
                x.IsApplicable = isChecked;
            }
        });
        this.filesData = newTable;

        this.ValidateFilesData();
    }

    previewApplicable($event) {
        let newTable = [];
        newTable = JSON.parse(JSON.stringify(this.filesData));
        if (!this._table.filteredValue) {
            // no filter applied
            newTable = newTable.map(item => {
                item.IsApplicable = $event.target.checked;
                return item;
            });
        } else {
            const filteredTable = JSON.parse(JSON.stringify(this._table.filteredValue));
            filteredTable.forEach(item => {
                newTable = newTable.map(row => {
                    item.tabId === row.tabId ? row.IsApplicable = $event.target.checked : '';
                    return row;
                });
            });
        }
        this.filesData = newTable;
    }

    changeYearType($event) {
        let newTable = [];
        newTable = JSON.parse(JSON.stringify(this.filesData));
        const filteredTable = this.filesData.filter(x => x.IsProcessed === false && x.IsApplicable === true && ['1', '2', '4'].includes
            (x.periodIdYear + ''));
        filteredTable.forEach(item => {
            newTable = newTable.map(row => {
                item.tabId === row.tabId ? row.YearType = this.yearTypeHeader : '';
                return row;
            });
        });
        this.filesData = newTable;
    }

    previewChangeCurrency($event) {
        let newTable = [];
        newTable = JSON.parse(JSON.stringify(this.filesData));
        const filteredTable = this.filesData.filter(x => x.IsProcessed === false && x.IsApplicable === true);
        filteredTable.forEach(item => {
            newTable = newTable.map(row => {
                item.tabId === row.tabId ? row.currencyId = parseInt($event.target.value, 10) : '';
                return row;
            });
        });
        this.filesData = newTable;
    }

    previewChangeTabGroup($event) {
        let newTable = [];
        newTable = JSON.parse(JSON.stringify(this.filesData));
        const filteredTable = this.filesData.filter(x => x.IsProcessed === false && x.IsApplicable === true);
        filteredTable.forEach(item => {
            newTable = newTable.map(row => {
                item.tabId === row.tabId ? row.tabGroupId = $event.target.value : '';
                return row;
            });
        });
        this.filesData = newTable;
    }

    previewChangeEntity1($event) {
        let newTable = [];
        newTable = JSON.parse(JSON.stringify(this.filesData));
        const filteredTable = this.filesData.filter(x => x.IsProcessed === false && x.IsApplicable === true);
        filteredTable.forEach(item => {
            newTable = newTable.map(row => {
                item.tabId === row.tabId ? (row.entity1Id = parseInt($event.target.value, 10), row.entity1Preview = '') : '';
                return row;
            });
        });
        this.filesData = newTable;
        this.ValidateFilesData();
    }

    previewChangeEntity2($event) {
        let newTable = [];
        newTable = JSON.parse(JSON.stringify(this.filesData));
        const filteredTable = this.filesData.filter(x => x.IsProcessed === false && x.IsApplicable === true);
        filteredTable.forEach(item => {
            newTable = newTable.map(row => {
                item.tabId === row.tabId ? (row.entity2Id = parseInt($event.target.value, 10), row.entity2Preview = '') : '';
                return row;
            });
        });
        this.filesData = newTable;
        this.ValidateFilesData();
    }

    previewChangePeriod($event, periodType: string) {
        let newTable = [];
        newTable = JSON.parse(JSON.stringify(this.filesData));
        const filteredTable = this.filesData.filter(x => x.IsProcessed === false && x.IsApplicable === true);
        filteredTable.forEach(item => {
            newTable = newTable.map(row => {
                if (periodType === 'periodId') {
                    item.tabId === row.tabId ? (row.periodId = parseInt($event.target.value, 10), row.periodPreview = '') : '';
                } else if (periodType === 'periodIdYear') {
                    item.tabId === row.tabId ? (
                        row.periodIdYear = parseInt($event.target.value, 10),
                        row.periodPreviewYear = '',
                        row.YearType = this.isFiscalMonthDec ? row.YearType : ''
                    ) : '';
                }
                return row;
            });
        });

        this.filesData = newTable;
        this.ValidateFilesData();
    }

  onEntityChange($event, index, propertyToClear) {
        if (Array.isArray(propertyToClear)) {
            propertyToClear.forEach(x => {
              if (this.isFiscalMonthDec && x === 'YearType') {
                this.filesData[index].periodIdYear = parseInt($event.target.value, 10)
                return;
              }
              this.filesData[index][x] = '';
            });
        } else {
          if (propertyToClear === 'periodPreview') {
            this.filesData[index].periodId = parseInt($event.target.value, 10)
          } else if (propertyToClear === 'entity1Preview') {
            this.filesData[index].entity1Id = parseInt($event.target.value, 10)
          } else if (propertyToClear === 'entity2Preview') {
            this.filesData[index].entity2Id = parseInt($event.target.value, 10)
          }
          this.filesData[index][propertyToClear] = '';
        }
        this.ValidateSingleFileData(this.filesData[index]);
    }

    copyText(event, fieldName: string, indexValue: number) {

        if (!(this.currentSelection && Object.keys(this.currentSelection).length === 0)) {
            const fullString = event.target.innerText;

            const rowId = this.currentSelection['rowId'];
            const propertyName = this.currentSelection['propertyName'];
            let isSelectedTabSame = false;
            if (window.getSelection) {
                const range = window.getSelection().getRangeAt(0);
                const startPosition = range.startOffset;
                const getPosition = range.toString();
                const endPosition = getPosition.length + startPosition;
                // if (startPosition == -1) {
                //  startPosition = 0;
                //  endPosition = endPosition - 1;
                // }

                const start_position = startPosition;
                const end_position = endPosition;

                if (start_position === end_position) {
                    return false;
                }

                let selectedString = fullString.substring(start_position, end_position);


                if (propertyName === 'periodPreviewYear') {
                    if (this.filesData[indexValue].periodIdYear === 1 && fieldName === 'fileName') {
                        isSelectedTabSame = true;
                    } else if (this.filesData[indexValue].periodIdYear === 2 && fieldName === 'tabName') {
                        isSelectedTabSame = true;
                    } else if (this.filesData[indexValue].periodIdYear === 4) {
                        isSelectedTabSame = true;
                    } else {
                        isSelectedTabSame = false;
                    }
                    if (selectedString.length === 2) {
                        selectedString = (2000 + parseInt(selectedString, 10)).toString();
                    }
                } else if (propertyName === 'periodPreview') {
                    if (this.filesData[indexValue].periodId === 1 && fieldName === 'fileName') {
                        isSelectedTabSame = true;
                    } else if (this.filesData[indexValue].periodId === 2 && fieldName === 'tabName') {
                        isSelectedTabSame = true;
                    } else if (this.filesData[indexValue].periodId === 4) {
                        isSelectedTabSame = true;
                    } else {
                        isSelectedTabSame = false;
                    }
                } else if (propertyName === 'entity1Preview') {
                    if (this.filesData[indexValue].entity1Id === 1 && fieldName === 'fileName') {
                        isSelectedTabSame = true;
                    } else if (this.filesData[indexValue].entity1Id === 2 && fieldName === 'tabName') {
                        isSelectedTabSame = true;
                    } else if (this.filesData[indexValue].entity1Id === 4) {
                        isSelectedTabSame = true;
                    } else {
                        isSelectedTabSame = false;
                    }
                } else if (propertyName === 'entity2Preview') {
                    if (this.filesData[indexValue].entity2Id === 1 && fieldName === 'fileName') {
                        isSelectedTabSame = true;
                    } else if (this.filesData[indexValue].entity2Id === 2 && fieldName === 'tabName') {
                        isSelectedTabSame = true;
                    } else if (this.filesData[indexValue].entity2Id === 4) {
                        isSelectedTabSame = true;
                    } else {
                        isSelectedTabSame = false;
                    }
                }
                if (isSelectedTabSame) {
                    if (rowId === indexValue || this.filesData[indexValue].periodId === 4 || this.filesData[indexValue].periodIdYear === 4) {
                        this.filesData[rowId][propertyName] = selectedString;
                    }
                    for (let nextRowId = rowId + 1; nextRowId < this.filesData.length; nextRowId++) {
                        let allowCopy = false;

                        if (this.filesData[nextRowId]['IsProcessed'] === false && this.filesData[nextRowId]['IsApplicable'] === true) {
                            let copystring = '';
                            switch (propertyName) {
                                case 'periodPreview':
                                    if ((this.filesData[nextRowId]['periodId'] === this.filesData[rowId]['periodId']) ||
                                        (this.filesData[nextRowId]['periodId'] + '' === '')) {
                                        this.filesData[nextRowId]['periodId'] = this.filesData[rowId]['periodId'];
                                        if (this.filesData[nextRowId]['periodId'] === 1) {
                                            copystring = this.filesData[nextRowId]['fileName'];
                                        } else if (this.filesData[nextRowId]['periodId'] === 2) {
                                            copystring = this.filesData[nextRowId]['tabName'];
                                        } else if (this.filesData[nextRowId]['periodId'] === 4) {
                                            copystring = fieldName === 'fileName' ? this.filesData[nextRowId]['fileName'] : this.filesData[nextRowId]['tabName'];
                                        }
                                        allowCopy = true;
                                    }
                                    break;

                                case 'periodPreviewYear':
                                    if ((this.filesData[nextRowId]['periodIdYear'] === this.filesData[rowId]['periodIdYear']) ||
                                        (this.filesData[nextRowId]['periodIdYear'] + '' === '')) {
                                        this.filesData[nextRowId]['periodIdYear'] = this.filesData[rowId]['periodIdYear'];
                                        if (this.filesData[nextRowId]['periodIdYear'] === 1) {
                                            copystring = this.filesData[nextRowId]['fileName'];
                                        } else if (this.filesData[nextRowId]['periodIdYear'] === 2) {
                                            copystring = this.filesData[nextRowId]['tabName'];
                                        } else if (this.filesData[nextRowId]['periodIdYear'] === 4) {
                                            copystring = fieldName === 'fileName' ? this.filesData[nextRowId]['fileName'] : this.filesData[nextRowId]['tabName'];
                                        }
                                        allowCopy = true;
                                    }
                                    break;

                                case 'entity1Preview':
                                    if ((this.filesData[nextRowId]['entity1Id'] === this.filesData[rowId]['entity1Id']) ||
                                        (this.filesData[nextRowId]['entity1Id'] === 0)) {
                                        this.filesData[nextRowId]['entity1Id'] = this.filesData[rowId]['entity1Id'];
                                        if (this.filesData[nextRowId]['entity1Id'] === 1) {
                                            copystring = this.filesData[nextRowId]['fileName'];
                                        } else if (this.filesData[nextRowId]['entity1Id'] === 2) {
                                            copystring = this.filesData[nextRowId]['tabName'];
                                        } else if (this.filesData[nextRowId]['entity1Id'] === 4 || this.filesData[nextRowId]['entity1Id'] === 1 ||
                                            this.filesData[nextRowId]['entity1Id'] === 2) {
                                            copystring = fieldName === 'fileName' ? this.filesData[nextRowId]['fileName'] : this.filesData[nextRowId]['tabName'];
                                        }
                                        allowCopy = true;
                                    }
                                    break;
                                case 'entity2Preview':
                                    if ((this.filesData[nextRowId]['entity2Id'] === this.filesData[rowId]['entity2Id']) ||
                                        (this.filesData[nextRowId]['entity2Id'] === 0)) {
                                        this.filesData[nextRowId]['entity2Id'] = this.filesData[rowId]['entity2Id'];
                                        if (this.filesData[nextRowId]['entity2Id'] === 1) {
                                            copystring = this.filesData[nextRowId]['fileName'];
                                        } else if (this.filesData[nextRowId]['entity2Id'] === 2) {
                                            copystring = this.filesData[nextRowId]['tabName'];
                                        } else if (this.filesData[nextRowId]['entity2Id'] === 4 || this.filesData[nextRowId]['entity2Id'] === 1 ||
                                            this.filesData[nextRowId]['entity2Id'] === 2) {
                                            copystring = fieldName === 'fileName' ? this.filesData[nextRowId]['fileName'] : this.filesData[nextRowId]['tabName'];
                                        }
                                        allowCopy = true;
                                    }
                                    break;
                            }

                            if (allowCopy && copystring !== '') {
                                this.filesData[nextRowId][propertyName] = copystring.substring(start_position, end_position).trim();
                                if (propertyName === 'periodPreviewYear' && this.filesData[nextRowId][propertyName].length === 2) {
                                    this.filesData[nextRowId][propertyName] = (2000 + parseInt(this.filesData[nextRowId][propertyName])).toString().trim();
                                }
                            }
                        }

                    }
                }
                this.ValidateFilesData();
            }
        }
    }
    closeEventPreview($event) {
        this.confirmdisplay = $event;
    }

    onBusinessSegClick(segmentName, entityName) {
        const columns = JSON.parse(JSON.stringify(this._table.columns));
        columns.map(item => {
            item.group === entityName ? item.visible = true : '';
            item.field === segmentName ? item.visible = false : '';
        });
        this._table.columns = columns;

        if (segmentName === 'businessSegment1') {
            this.hideShowBusinessSegment2(true);
        }

        this.ValidateFilesData();
    }

    hideShowBusinessSegment2(toShow: boolean) {
        this._table.columns.find(c => c.field === 'businessSegment2').visible = toShow;
    }

    previousButton() {
        this.confirmdisplay = false;
        this.router.navigate(['/engagement/', this.engagementId, 'uploadsource']);
    }
}
